import { roles } from '@nxsys/store/constants';
import { P6P9Updates } from '../../../modules/HMRCUpdates/P6P9';
import { StudentLoanUpdates } from '../../../modules/HMRCUpdates/StudentLoan';
import { PayrollCountryType } from '@nxsys/types/models/Common';

export const hmrcUpdateConfig = (payrollCountry: PayrollCountryType) => {
  if (payrollCountry === 'IRELAND') {
    return [];
  }
  return [
    {
      permittedRole: [roles.admin, roles.employer],
      path: '/hmrc-update/p6-p9',
      element: <P6P9Updates />,
    },
    {
      permittedRole: [roles.admin, roles.employer],
      path: '/hmrc-update/student-loan',
      element: <StudentLoanUpdates />,
    },
  ];
};
